import { useEffect, useState } from 'react'

export function ProcessingView({ handle, slug }: { handle: string; slug: string }) {
  const [dotCount, setDotCount] = useState(0)

  useEffect(() => {
    const t = setInterval(() => setDotCount(n => (n + 1) % 4), 420)
    return () => clearInterval(t)
  }, [])

  return (
    <>
      <style>{`
        @keyframes id-scan {
          0%   { transform: translateY(0); opacity: 0.9; }
          49%  { opacity: 0.9; }
          50%  { transform: translateY(220px); opacity: 0; }
          51%  { transform: translateY(0); opacity: 0; }
          52%  { opacity: 0.9; }
          100% { transform: translateY(220px); opacity: 0.9; }
        }
        @keyframes id-spin {
          to { transform: rotate(360deg); }
        }
        @keyframes id-fadein {
          from { opacity: 0; transform: translateY(6px); }
          to   { opacity: 1; transform: translateY(0); }
        }
        @keyframes id-pulse-grid {
          0%, 100% { opacity: 0.18; }
          50%       { opacity: 0.38; }
        }
        .id-processing-wrap {
          position: fixed; inset: 0;
          display: flex; flex-direction: column;
          align-items: center; justify-content: center;
          background: var(--bg);
          animation: id-fadein 0.4s ease both;
        }
        .id-grid-art {
          position: relative;
          width: 220px; height: 220px;
          margin-bottom: 48px;
          animation: id-pulse-grid 2.8s ease-in-out infinite;
        }
        .id-grid-art svg {
          width: 100%; height: 100%;
        }
        .id-scan-beam {
          position: absolute;
          top: 0; left: -2px; right: -2px;
          height: 1px;
          background: linear-gradient(90deg,
            transparent 0%,
            rgba(0,229,255,0.0) 10%,
            rgba(0,229,255,0.9) 40%,
            var(--lime) 50%,
            rgba(0,229,255,0.9) 60%,
            rgba(0,229,255,0.0) 90%,
            transparent 100%
          );
          box-shadow: 0 0 12px 2px rgba(163,230,53,0.5);
          animation: id-scan 2.1s linear infinite;
        }
        .id-spinner {
          width: 28px; height: 28px;
          border: 2px solid var(--line);
          border-top-color: var(--accent);
          border-radius: 50%;
          animation: id-spin 0.75s linear infinite;
          margin-bottom: 22px;
        }
        .id-label {
          font-family: var(--mono);
          font-size: 13px;
          color: var(--fg-3);
          letter-spacing: 0.04em;
          min-width: 160px;
          text-align: center;
        }
        .id-path {
          font-family: var(--mono);
          font-size: 11px;
          color: var(--lime);
          margin-top: 10px;
          opacity: 0.7;
        }
      `}</style>
      <div className="id-processing-wrap">
        <div className="id-grid-art">
          <svg viewBox="0 0 220 220" fill="none" xmlns="http://www.w3.org/2000/svg">
            {[0,1,2,3,4].map(i => (
              <line key={`v${i}`} x1={44*i} y1="0" x2={44*i} y2="220"
                stroke="var(--lime)" strokeWidth="0.75" strokeOpacity="0.5" />
            ))}
            <line x1="220" y1="0" x2="220" y2="220" stroke="var(--lime)" strokeWidth="0.75" strokeOpacity="0.5" />
            {[0,1,2,3,4].map(i => (
              <line key={`h${i}`} x1="0" y1={44*i} x2="220" y2={44*i}
                stroke="var(--lime)" strokeWidth="0.75" strokeOpacity="0.5" />
            ))}
            <line x1="0" y1="220" x2="220" y2="220" stroke="var(--lime)" strokeWidth="0.75" strokeOpacity="0.5" />
            {[0,1,2,3,4,5].flatMap(r => [0,1,2,3,4,5].map(c => (
              <circle key={`d${r}${c}`} cx={44*c} cy={44*r} r="1.5"
                fill="var(--accent)" fillOpacity="0.55" />
            )))}
          </svg>
          <div className="id-scan-beam" />
        </div>
        <div className="id-spinner" />
        <div className="id-label">
          {'indexing' + '.'.repeat(dotCount).padEnd(3, ' ')}
        </div>
        <div className="id-path">{handle}/{slug}</div>
      </div>
    </>
  )
}
